import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';
import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

export type FlexCardProps = Omit<MuiCardProps, 'display'>;

export const FlexCard = (props: FlexCardProps) => {
  const { sx, ...restProps } = props;
  return (
    <MuiCard {...restProps} sx={[{ flexDirection: 'column', width: '100%' }, ...toSxArray(sx), { display: 'flex' }]} />
  );
};
